// Pure helper behind the Podwórko upgrade table: one row per level 1..5 with what the
// level gives, its cost and whether the player already has it / can buy it next / must
// wait. Keys of `levels`/`costs` are strings because they arrive as JSON object keys.
export const BACKYARD_MAX_LEVEL = 5;

export function upgradeTableRows({ level, money, levels, costs }) {
  const cur = Number.isInteger(level) ? level : 1;
  const cash = Number.isFinite(money) ? money : 0;
  const rows = [];
  for (let lvl = 1; lvl <= BACKYARD_MAX_LEVEL; lvl++) {
    const cost = lvl === 1 ? null : (costs?.[String(lvl)] ?? null);
    let status = 'locked';
    if (lvl <= cur) status = 'have';
    else if (lvl === cur + 1) status = 'next';
    const shortBy = status === 'next' && cost != null ? Math.max(0, cost - cash) : 0;
    rows.push({ level: lvl, text: levels?.[String(lvl)] ?? '', cost, status, shortBy });
  }
  return rows;
}
